import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

// Thumbnail for videos
const VideoThumbnail = ({ media, onClick }) => {
  const { poster_url: posterUrl, media_url: mediaUrl } = media;

  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-block',
        cursor: 'pointer',
        borderRadius: 4,
        overflow: 'hidden',
        width: 100,
        height: 56,
        backgroundColor: posterUrl ? 'transparent' : '#ccc',
      }}
      onClick={() => onClick(mediaUrl, posterUrl, 'video')}
    >
      {posterUrl ? (
        <img
          src={posterUrl}
          alt="video thumbnail"
          width={100}
          height={56}
          style={{ objectFit: 'cover', display: 'block' }}
        />
      ) : (
        <div
          style={{
            width: 100,
            height: 56,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        />
      )}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none',
          fontSize: 28,
          color: posterUrl ? 'white' : '#555',
          textShadow: posterUrl ? '0 0 8px rgba(0, 0, 0, 0.7)' : 'none',
          userSelect: 'none',
        }}
      >
        ►
      </div>
    </div>
  );
};

const PostList = ({ posts = [], onEdit, onDelete, onImageClick, user }) => {
  const localizedDate = (dateString, timezone) => {
    if (!timezone) return dateString;
    const date = new Date(dateString);
    const options = { day: '2-digit', month: 'short', year: 'numeric', timeZone: timezone };
    const formattedDate = date.toLocaleDateString('en-GB', options).replace(/ /g, '-');
    const timeZoneName = date.toLocaleDateString('en-US', {
      timeZone: timezone,
      timeZoneName: 'short',
    }).split(' ').pop();
    return `${formattedDate} (${timeZoneName})`;
  };

  return (
    <div className="post-list">
      {posts.map((post) => {
        const coordinates =
          post.latitude && post.longitude
            ? [parseFloat(post.latitude), parseFloat(post.longitude)]
            : null;

        const displayDate = post.timezone
          ? localizedDate(post.post_date || post.created_at, post.timezone)
          : (post.post_date || post.created_at || '').slice(0, 10);

        return (
          <div
            key={post.id}
            className="post-card"
            style={{
              ...cardStyle,
              display: 'flex',
              flexWrap: 'wrap',
              gap: '20px',
              marginBottom: '40px',
            }}
          >
            <div style={{ flex: '1 1 300px', minWidth: '0' }}>
              <h2>{post.title}</h2>

              <div style={{ marginBottom: '10px', fontSize: '0.9rem', color: '#555' }}>
                🕒 <strong>Date:</strong> {displayDate}
              </div>

              <div
                style={{
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                  padding: '10px',
                  backgroundColor: '#fff',
                  marginBottom: '10px',
                }}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: post.content }}
                />
              </div>



              <div className="image-thumbnails" style={imageGridStyle}>
                {(post.media || []).map((media) => {
                  if (media.content_type.startsWith('image')) {
                    return (
                      <img
                        key={media.id}
                        src={media.media_url}
                        alt="thumbnail"
                        width={100}
                        style={{ cursor: 'pointer' }}
                        onClick={() => onImageClick(media.media_url, media.poster_url, 'image')}
                      />
                    );
                  } else if (media.content_type.startsWith('video')) {
                    return (
                      <VideoThumbnail
                        key={media.id}
                        media={media}
                        onClick={onImageClick}
                      />
                    );
                  }
                  return null;
                })}
              </div>

              {(post.location || post.timezone) && (
                <div style={{ fontSize: '0.9rem', color: '#555', marginTop: '15px', marginBottom: '10px' }}>
                  {post.location && (
                    <div>
                      📍 <strong>Location:</strong> {post.location}
                    </div>
                  )}
                </div>
              )}

              {user?.is_superuser && (
                <div style={{ marginTop: '10px' }}>
                  <button onClick={() => onEdit(post)} style={editButtonStyle}>
                    Edit
                  </button>
                  <button onClick={() => onDelete(post.id)} style={deleteButtonStyle}>
                    Delete
                  </button>
                </div>
              )}
            </div>

            {coordinates && (
              <div style={mapContainerStyle}>
                <MapContainer
                  center={coordinates}
                  zoom={13}
                  scrollWheelZoom={false}
                  style={{ height: '100%', width: '100%' }}
                >
                  <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution="&copy; OpenStreetMap contributors"
                  />
                  <Marker position={coordinates} />
                </MapContainer>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

// Styles
const cardStyle = {
  background: '#fff',
  padding: '15px',
  borderRadius: '8px',
  boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
};

const mapContainerStyle = {
  width: '300px',
  height: '200px',
  flexShrink: 0,
  borderRadius: '8px',
  overflow: 'hidden',
};

const imageGridStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '10px',
  marginTop: '10px',
};

const editButtonStyle = {
  padding: '6px 12px',
  backgroundColor: '#007bff',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  marginRight: '10px',
  cursor: 'pointer',
};

const deleteButtonStyle = {
  padding: '6px 12px',
  backgroundColor: '#dc3545',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
};

export default PostList;
